import { Doctor } from "../services/doctor";

// Fica fora de `utils/memed.js` de propósito: aquele módulo é DOM puro e o
// teste dele não carrega axios, store nem interceptors.

// O backend distingue "médico não aprovado" (403) de "Memed fora do ar" (503).
// Traduzir aqui é o que permite a tela dizer a coisa certa em vez de chutar.
function causeFrom(error) {
  const errorType =
    error && error.response && error.response.data
      ? error.response.data.error_type
      : null;

  if (errorType === "memed_not_approved") return "memed:not-approved";
  if (errorType === "memed_unavailable") return "memed:unavailable";

  // Sem resposta do servidor (rede, timeout) tentar de novo pode resolver.
  return "memed:unavailable";
}

export async function resolveMemedToken(currentUser) {
  const stored =
    currentUser &&
    currentUser.doctor_property &&
    currentUser.doctor_property.memed_token;
  if (stored) return stored;

  let response;
  try {
    response = await Doctor.refreshToken();
  } catch (error) {
    throw new Error(causeFrom(error));
  }

  const token = response && response.data && response.data.memed_token;
  if (!token) throw new Error("memed:not-approved");
  return token;
}
